/**
 * Service: terminalsApi
 */
angular.module('acme.common.service.terminalsApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('TerminalsApiService', [ '$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/terminal';
        this.config.service = endpoint + '/terminal';
        this.templates.service = endpoint + '/terminal/template';
        return this;
      },

      list: function(props) {
        var q = '',
            av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/list' + q, version: 'v2' })
        });
      },

      detail: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/' + id, version: 'v2' })
        });
      },

      update: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            id: props.id,
            terminalId: props.terminalId,
            amount: props.amount,
            name: props.name,
            description: props.description,
            type: props.type
          }
        });
      },

      create: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            terminalId: props.terminalId,
            amount: props.amount,
            name: props.name,
            description: props.description,
            type: props.type,
            configId: props.configId
          }
        });
      },

      remove: function(id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({ url: this.service + '/' + id, version: 'v2' })
        });
      },
      
      config: {
        service: '',
        
        list: function (id) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/assigned/' + id, version: 'v2' })
          });
        },
        
        update: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service + '/assign', version: 'v2' }),
            data: props
          });
        },

        detail: function(props) {
          var q = '',
              av = new ApiVersionFactory(),
              qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['id', 'published']
                }
              });

          q = qs.query;

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/config' + q, version: 'v2' })
          });
        },

        terminalDetail: function(props) {
          var q,
              av = new ApiVersionFactory(),
              qs = new QueryStringBuilderFactory({
                props: props,
                fields: {
                  optional: ['terminalId', 'published']
                }
              });
          q = qs.query;

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/config' + q, version: 'v2' })
          });
        }
        
      },

      templates: {
        service: '',

        update: function (id, props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service + '/mappings/' + id, version: 'v2' }),
            data: props
          });
        },
      }

    };

}]);